function toggleDark() {
  document.body.classList.toggle('dark-mode');
  const btn = document.getElementById('dark-toggle');
  const isDark = document.body.classList.contains('dark-mode');
  btn.textContent = isDark ? '☀️' : '🌙';
  localStorage.setItem('darkMode', isDark);
}
window.addEventListener('DOMContentLoaded', () => {
  if (localStorage.getItem('darkMode') === 'true') {
    document.body.classList.add('dark-mode');
    document.getElementById('dark-toggle').textContent = '☀️';
  }
});
